<script>
  import { isValidEmail } from '../helpers/form-validation.js'
  import { link, replace } from 'svelte-spa-router'
  import { onMount } from 'svelte'
  import AuthContainer from './AuthContainer.svelte'
  import TextInput from '../components/TextInput.svelte'
  import Button from '../components/Button.svelte'
  import { snackBarStore, userStore } from '../state/store'
  import { t } from '../i18n/i18n'

  let email = ''

  $: emailValid = isValidEmail(email)
  $: formValid = emailValid

  onMount(() => userStore.set({}))

  const submitForm = async () => {
    try {
      const response = await fetch('/api/user-meta', {
        method: 'POST',
        body: JSON.stringify({
          email,
          forgot_password: true,
          origin: window.location.origin
        })
      })
      if (!response.ok) throw new Error($t.incorrect_credentials)
      
      snackBarStore.set({ message: $t.check_email_password_reset, type: 'success', selfDestruct: true })
      replace('/sign-in/')

    } catch (error) {
      snackBarStore.set({ message: $t.incorrect_credentials, type: 'error', selfDestruct: true })
    }
  }

</script>
  
<style>
  form {
    margin-bottom: 2rem;
  }

  p {
    font-size: 1.6rem;
    margin-top: 2.8rem;
  }
</style>
  
<AuthContainer>
  <h1>{$t.reset_password}</h1>
  <form on:submit|preventDefault={submitForm}>
    <TextInput
      id='email'
      label='{$t.email}'
      valid={emailValid}
      validityMessage='{$t.valid_email}'
      type='email'
      value={email}
      on:input={event => (email = event.target.value)} />
    <Button type='submit' size='full' disabled={!formValid}>
      {$t.reset_password}
    </Button>
  </form>
  <p class='g-center'>
    <a href="/sign-in/" use:link>{$t['Back to Sign In']}</a>
  </p>
</AuthContainer>
